import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Table } from 'react-bootstrap';
import rest from '../axios';
import './css/usuarios.css';

const UserDashboard = () => {
  const [users, setUsers] = useState([]);
  const [condominiosStats, setCondominiosStats] = useState([]);  // Renomeado de 'setFilterCondominio' para 'setCondominios'
  const [condominios, setCondominios] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [search, setSearch] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [filteredCondominios, setFilteredCondominios] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [formData, setFormData] = useState({
    first_name: '', last_name: '', email: '', phone: '', contact_type: 'usuario', community_id: '', password: ''
  });

  // Estatísticas de usuários
  const [usuarioPorCondominio, setTotalPorCondominio] = useState(0);
  const [totalUsuarios, setTotalUsuarios] = useState(0);
  const [usuariosUltimas24h, setUsuariosUltimas24h] = useState(0);
  const [usuariosUltimos7Dias, setUsuariosUltimos7Dias] = useState(0);
  const [usuariosUltimos30Dias, setUsuariosUltimos30Dias] = useState(0);

  // Filtro de datas
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    fetchUsers();
    fetchCommunities();
  }, []);

  useEffect(() => {
    setFilteredUsers(
      users.filter(u => {
        const text = `${u.first_name} ${u.last_name} ${u.email} ${u.phone}`.toLowerCase();
        return text.includes(search.toLowerCase());
      })
    );
  }, [search, users]);

  useEffect(() => {
    setFilteredCondominios(
      condominiosStats.filter(c => {
        const text = `${c.name} ${c._count?.users}`.toLowerCase();
        return text.includes(search.toLowerCase());
      })
    );
  }, [search, condominiosStats]);

  // Função para filtrar os usuários com base nas datas
  const filterByDate = () => {
    setFilteredUsers(
      users.filter(user => {
        const userDate = new Date(user.created_at);
        const start = startDate ? new Date(startDate) : null;
        const end = endDate ? new Date(endDate) : null;

        // Verifica se a data do usuário está dentro do intervalo
        if (start && userDate < start) return false;
        if (end && userDate > end) return false;
        return true;
      })
    );
  };

  const fetchUsers = async () => {
    try {
      const res = await rest.get('/admin/users');
      setUsers(res.data?.data?.users || []);
      setCondominios(res.data?.data?.communities || []);
      setCondominiosStats(res.data?.data?.communitiesStats || []);
      setTotalUsuarios(res.data?.data?.totalUsers || 0);
      setUsuariosUltimas24h(res.data?.data?.usersLast24h || 0);
      setUsuariosUltimos7Dias(res.data?.data?.usersLast7Days || 0);
      setUsuariosUltimos30Dias(res.data?.data?.usersLast30Days || 0);
    } catch (err) {
      console.error('Erro ao buscar usuários:', err);
    }
  };

  const fetchCommunities = async () => {
    try {
      const res = await rest.get('/admin/communities');
      setCommunities(res.data?.data?.communities || []);
    } catch (err) {
      console.error('Erro ao buscar condomínios:', err);
    }
  };


  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleAddUser = async () => {
    try {
      await rest.post('/admin/users', {
        ...formData,
        community_id: Number(formData.community_id)
      });
      fetchUsers();
      setShowAddModal(false);
    } catch (err) {
      console.error('Erro ao adicionar usuário:', err);
    }
  };

  const handleEditUser = async () => {
    try {
      await rest.put(`/admin/users/${selectedUser.id}`, {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        password: formData.password,
        phone: formData.phone,
        contact_type: formData.contact_type,
        community_id: Number(formData.community_id),
        city_id: Number(formData.city_id),
      });
      fetchUsers();
      setShowEditModal(false);
    } catch (err) {
      console.error('Erro ao editar usuário:', err);
    }
  };

  const handleDeleteUser = async () => {
    try {
      await rest.delete(`/admin/users/${selectedUser.id}`);
      fetchUsers();
      setShowDeleteModal(false);
    } catch (err) {
      console.error('Erro ao excluir usuário:', err);
    }
  };

  const openEditModal = (user) => {
    setSelectedUser(user);
    setFormData({ ...user, password: '' });
    setShowEditModal(true);
  };

  const openDeleteModal = (user) => {
    setSelectedUser(user);
    setShowDeleteModal(true);
  };

  return (
    <div className="page-wrapper1">
      {/* Estatísticas de Moradores por Condomínio */}
      <h4>Estatísticas de Moradores por Condomínio</h4>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Condomínio</th>
            <th>Total de Moradores</th>
          </tr>
        </thead>
        <tbody>
          {filteredCondominios.map(community => (
            <tr key={community.id}>
              <td>{community.name || 'Usuários prestadores de serviços'}</td>
              <td>{community._count?.users || 'N/A'}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th>Total Geral</th>
            <th>{totalUsuarios}</th>
          </tr>
        </tfoot>
      </Table>

      <h2>Usuários cadastrados nas últimas 24 horas: {usuariosUltimas24h}</h2>
      <h4>Usuários cadastrados nos últimos 7 dias: {usuariosUltimos7Dias}</h4>
      <h4>Usuários cadastrados nos últimos 30 dias: {usuariosUltimos30Dias}</h4>
      <br></br>

      <input
        type="text"
        className="form-control mb-3"
        placeholder="Pesquisar por nome, email ou telefone..."
        value={search}
        onChange={e => setSearch(e.target.value)}
      />

      <br></br>

      {/* Filtros de Data */}
      <div className="d-flex gap-3 mb-3 align-items-center">
        <Form.Group className="mb-0 flex-grow-1">
          <Form.Label>Data Início</Form.Label>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-0 flex-grow-1">
          <Form.Label>Data Fim</Form.Label>
          <Form.Control
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </Form.Group>
        <Button onClick={filterByDate} className="ml-2">Filtrar</Button>
      </div>

      <Button className="mb-3" onClick={() => setShowAddModal(true)}>Adicionar Usuário</Button>

      {/* Tabela para desktop */}
      <div className="user-table">
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Email</th>
              <th>Telefone</th>
              <th>Tipo de Contato</th>
              <th>Condomínio</th>
              <th>Data de Cadastro</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map(user => (
              <tr key={user.id}>
                <td>{user.first_name} {user.last_name}</td>
                <td>{user.email}</td>
                <td>{user.phone || 'N/A'}</td>
                <td>{user.contact_type}</td>
                <td>{user.community_name || 'N/A'}</td>
                <td>{new Date(user.created_at).toLocaleDateString()}</td>
                <td>
                  <div className="d-flex flex-wrap gap-2">
                    <Button variant="warning" size="sm" onClick={() => openEditModal(user)}>Editar</Button>
                    <Button variant="danger" size="sm" onClick={() => openDeleteModal(user)}>Excluir</Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Modal Adicionar */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Header closeButton><Modal.Title>Adicionar Usuário</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group><Form.Label>Nome</Form.Label><Form.Control name="first_name" onChange={handleInput} /></Form.Group>
            <Form.Group><Form.Label>Sobrenome</Form.Label><Form.Control name="last_name" onChange={handleInput} /></Form.Group>
            <Form.Group><Form.Label>Email</Form.Label><Form.Control name="email" type="email" onChange={handleInput} /></Form.Group>
            <Form.Group><Form.Label>Senha</Form.Label><Form.Control name="password" type="password" onChange={handleInput} /></Form.Group>
            <Form.Group><Form.Label>Telefone</Form.Label><Form.Control name="phone" onChange={handleInput} /></Form.Group>
            <Form.Group><Form.Label>Tipo</Form.Label><Form.Select name="contact_type" onChange={handleInput} defaultValue="usuario">
              <option value="usuario">Usuário</option>
              <option value="prestador_de_servico">Prestador</option>
              <option value="admin">Admin</option>
            </Form.Select></Form.Group>
            <Form.Group><Form.Label>Condomínio</Form.Label><Form.Select name="community_id" onChange={handleInput}>
              <option value="">Selecione</option>
              {communities.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </Form.Select></Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={handleAddUser}>Adicionar</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Editar */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton><Modal.Title>Editar Usuário</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group><Form.Label>Nome</Form.Label><Form.Control name="first_name" value={formData.first_name} onChange={handleInput} /></Form.Group>
            <Form.Group><Form.Label>Sobrenome</Form.Label><Form.Control name="last_name" value={formData.last_name} onChange={handleInput} /></Form.Group>
            <Form.Group><Form.Label>Email</Form.Label><Form.Control name="email" type="email" value={formData.email} onChange={handleInput} /></Form.Group>
            <Form.Group><Form.Label>Telefone</Form.Label><Form.Control name="phone" value={formData.phone} onChange={handleInput} /></Form.Group>
            <Form.Group><Form.Label>Tipo</Form.Label><Form.Select name="contact_type" value={formData.contact_type} onChange={handleInput}>
              <option value="usuario">Usuário</option>
              <option value="prestador_de_servico">Prestador</option>
              <option value="admin">Admin</option>
            </Form.Select></Form.Group>
            <Form.Group><Form.Label>Condomínio</Form.Label><Form.Select name="community_id" value={formData.community_id} onChange={handleInput}>
              <option value="">Selecione</option>
              {communities.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </Form.Select></Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={handleEditUser}>Salvar</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Exclusão */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton><Modal.Title>Confirmar Exclusão</Modal.Title></Modal.Header>
        <Modal.Body>
          Tem certeza que deseja excluir o usuário <strong>{selectedUser?.first_name} {selectedUser?.last_name}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancelar</Button>
          <Button variant="danger" onClick={handleDeleteUser}>Excluir</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserDashboard;
